var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { Button, Icon, Link, Text } from '@paypalcorp/pp-react';
import { PASSWORD } from '../common/views';
export default ({ authEventHandler, email, localizedContent, logger, setView }) => {
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            logger.track('generic_error_rendered');
        }))();
    }, []);
    return (React.createElement("div", { style: { textAlign: 'center' } },
        React.createElement(Text, { size: "xl2" },
            React.createElement(Icon, { name: "error", size: "xl", style: { display: 'block' } }),
            localizedContent('genericErrorHeading')),
        React.createElement(Button, { theme: "v2", onClick: () => {
                logger.track('user_opted_out');
                setView(PASSWORD);
            }, style: { width: '100%', marginBottom: '20px' } }, localizedContent('loginWithPassword')),
        React.createElement(Link, { href: "#", theme: "v2", onClick: () => {
                logger.track('user_opted_out');
                authEventHandler({ event: 'userOptedOut', data: { email } });
            } }, localizedContent('checkoutAsGuest'))));
};
